import { FeatureFlag } from '@ps/web-core-enums';

import useFeature from '@swf/core/hooks/useFeature';
import type { FlowConfig } from '@swf/core/types/Wizard';

import useMultiScreenSignupFlow from './useMultiScreenSignupFlow';
import useSignUpBlackListFlow from './useSignUpBlackListFlow';
import useSingleScreenSignupFlow from './useSingleScreenSignupFlow';

const useSignupFlow = (): FlowConfig => {
  const blacklistCheck = useFeature(FeatureFlag.BlackListCheck);
  const isSWCSignupDepositEnabled = useFeature(FeatureFlag.SwcSignupOnePage);
  const blackListedFlow = useSignUpBlackListFlow();
  const multiScreenSignupFlow = useMultiScreenSignupFlow();
  const singleScreenSignupFlow = useSingleScreenSignupFlow();

  if (blacklistCheck) {
    return blackListedFlow;
  }
  if (isSWCSignupDepositEnabled) {
    return singleScreenSignupFlow;
  }

  return multiScreenSignupFlow;
};

export default useSignupFlow;
